import { createReducer, on } from '@ngrx/store';

import * as fromRootStore from '@apps/root/store';
import * as fromAuthLoginActions from '@apps/auth/store/login/login.actions';
import * as fromAuthProfileActions from '@apps/auth/store/profile/profile.actions';
import * as fromCopilsActions from '@apps/back/store/pata/copils/copils.actions';
import { BackPataCopilsInitialState, copilsAdapter } from './copils.state';

export const BackPataCopilsReducer = createReducer(
    BackPataCopilsInitialState,
    on(
        fromRootStore.RootImpeStoreActions.RootImpersonateSet,
        fromRootStore.RootImpeStoreActions.RootImpersonateUnset,
        fromAuthProfileActions.AuthProfileApplicationRolesSet,
        fromAuthProfileActions.AuthProfileApplicationRolesReset,
        fromAuthLoginActions.AuthLogout,
        () => BackPataCopilsInitialState
    ),
    on(
        fromCopilsActions.BackPataCopilsListRequested,
        (state) => ({
            ...state,
            isLoading: true,
            isLoaded: false,
            isOups: false,
            isEmpty: false
        })
    ),
    on(
        fromCopilsActions.BackPataCopilsListSucceeded,
        (state, { copils }) => ({
            ...state,
            isLoading: false,
            isLoaded: true,
            isOups: false,
            isEmpty: copils && copils.length === 0,
            copils: copilsAdapter.setAll(copils, state.copils)
        })
    ),
    on(
        fromCopilsActions.BackPataCopilsListFailed,
        (state) => ({
            ...state,
            isLoading: false,
            isLoaded: false,
            isOups: true,
            isEmpty: false,
            copils: copilsAdapter.removeAll(state.copils)
        })
    ),
    on(
        fromCopilsActions.BackPataCopilsListFilterTriggered,
        (state, { done }) => ({
            ...state,
            planifiedFilter: done
        })
    ),
    on(
        fromCopilsActions.BackPataCopilsQsWordSet,
        (state, { qsWord }) =>
        {
            return {
                ...state,
                qsWord: qsWord.toLowerCase()
            };
        }
    )
);
